<template>
  <div class="container-box">
    <div class="title font-size-text07">{{ item.name }}</div>
    <span class="count font-size-text1">{{ item.count }}</span>
    <slot name="superWrap">
      <div class="super-count-wrap font-size-text06" v-if="showSuper">
        <span class="super-name">{{ item.superName }}</span>
        <span
          class="super-count"
          :class="[parseFloat(item.superCount) < 0 ? 'green' : 'red']"
        >{{ item.superCount }}</span>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    showSuper: {
      default: true,
      type: Boolean
    },
    item: {
      default: () => {
        return {
          name: '',
          count: 0,
          superName: '',
          superCount: 0
        }
      },
      type: Object
    }
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
  mounted () {},
  watch: {},
  methods: {},
  components: {}
}
</script>

<style scoped lang="stylus">
.container-box {
  .count {
    display: inline-block;
  }

  .title, .count {
    margin-bottom: 0.3rem;
  }

  .super-count-wrap {
    .super-name {
      color: rgba(255, 255, 255, 0.6);
    }

    .super-count {
      margin-left: 0.2rem;

      &.red {
        color: red;
      }

      &.green {
        color: #00ff2b;
      }
    }
  }
}
</style>
